import { Button } from '@/components/ui';
import { useState, useRef, useEffect } from 'react';
import { InputInLabel, Icon, ErrorMessage, LoadingButton } from '../../ui';

import StoryZone from './StoryZone';

import useLadyService from '@/services/LadyService';
import axios from 'axios';
import baseUrl from '@/services/apiConfig';
import showToast from '../../toast/Toast';
import { makeRequest } from '@/services/makeRequest';
import { useSelector } from 'react-redux';
import {
	getAddStoriesStatus,
	setAddStoriesStatus,
	getAddStoriesPhoto,
	setAddStoriesPhoto,
	setStoriesStatus,
	getAddStoriesVideo,
	setAddStoriesVideo,
} from '@/stores/slices/popupSlice';
import Popup from '../Popup';
import { Link } from 'react-router-dom';
import '../../../components/pages/accounts/model/profiles/card/components/upAd/upAd.scss';

const AddStoriesPopup = ({ slug, setStories, stories, open, setOpen }) => {
	const { t, token, dispatch, userType } = useLadyService();

	const popupState = useSelector(getAddStoriesStatus);
	const statePhoto = useSelector(getAddStoriesPhoto);
	const stateVideo = useSelector(getAddStoriesVideo);

	const [media, setMedia] = useState([]);
	const [descValue, setDescValue] = useState('');

	const [descValueLength, setDescValueLength] = useState(0);

	const descChange = (e) => {
		const value = e.target.value;
		const limitedValue = value.substring(0, 100);
		setDescValueLength(limitedValue.length);
		setDescValue(limitedValue);
	};

	const [loading, setLoading] = useState(false);

	const loadStories = async (formData) => {
		setLoading(true);
		const route =
			statePhoto?.preview ??
			stateVideo?.preview ??
			baseUrl + `user/${slug}/stories`;
		try {
			const response = await axios.post(route, formData, {
				headers: {
					Authorization: token ? `Bearer ${token}` : '',
				},
			});

			if (response.status === 200) {
				const { profiles } = await makeRequest({
					route: `user/profiles`,
					method: 'GET',
					payload: { slug },
				});

				setStories(() => {
					return [...profiles[0]?.stories];
				});
				setMedia([]);
				setDescValue('');
				setDescValueLength(0);
				dispatch(setAddStoriesStatus(false));
				dispatch(setStoriesStatus(false));
				showToast({
					message: t('storiessuccess'),
					variant: 'success',
				});
				if (open) {
					handleClose();
				}
			} else if (response.status === 402) {
				showToast({
					message: t('insuff'),
					variant: 'error',
					type: 'insuff',
					userType: userType,
				});
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);

			console.error(error);
			const res = error.responce;

			showToast({
				message: t('oops'),
				subMessage: `server error ${res?.status}`,
				variant: `error`,
			});
		}
	};

	const onSubmit = (e) => {
		e.preventDefault();

		if (duration > 20) {
			showToast({
				message: `${t('maxval')}: 20 ${t('sek')} (<${duration.toFixed(1)}${t('sek')})`,
				variant: 'error',
			});
			return;
		}

		const fetchData = async () => {
			try {
				setStories([]);
				dispatch(setAddStoriesPhoto(false));
				const formData = new FormData();
				if (media?.length > 0) {
					formData.append('file', media[0]);
					formData.append('file_name', media[0]);
				} else if (!!statePhoto) {
					formData.append('file', statePhoto.name);
					formData.append('file_name', statePhoto.name);
				} else if (!!stateVideo) {
					formData.append('file', stateVideo.name);
					formData.append('file_name', stateVideo.name);
				} else {
					return;
				}

				descValue && formData.append('description', descValue);

				loadStories(formData);
			} catch (error) {
				showToast({
					message: t('oops'),
					variant: 'error',
				});
				console.error('error: ', error);
			}
		};

		fetchData();
	};

	const videoRef = useRef(null);
	const [duration, setDuration] = useState(0);

	useEffect(() => {
		const video = videoRef.current;

		video?.addEventListener('loadedmetadata', () => {
			setDuration(video.duration);
		});

		if (duration > 20) {
			setMedia(null);
			showToast({
				message: `${t('maxval')}: 20 ${t('sek')}`,
				variant: 'error',
			});
		} else {
			//console.log('=> duration', duration);
		}

		return () => {
			video?.removeEventListener('loadedmetadata', () => {});
		};
	}, [media, stateVideo]);

	const handleClose = () => {
		dispatch(setAddStoriesStatus(false));
		dispatch(setAddStoriesPhoto(false));
		dispatch(setAddStoriesVideo(false));
	};

	const [loadingPrice, setLoadingPrice] = useState(false);
	const [publish_price, setPublishPrice] = useState(null);

	const getPriceData = async () => {
		try {
			setLoadingPrice(true);
			const route = baseUrl + `user/profile/${slug}/story-price`;
			const response = await axios.get(route, {
				headers: {
					Authorization: token ? `Bearer ${token}` : '',
				},
			});
			if (response.status === 200) {
				setPublishPrice(response.data.price);
			} else {
				throw new Error(
					`server error code: ${response.status};`,
					response,
				);
			}
		} catch (error) {
			showToast({ message: t('oops'), variant: 'error' });
			console.error(error);
		} finally {
			setLoadingPrice(false);
		}
	};

	useEffect(() => {
		if (open || popupState) {
			getPriceData();
		}
	}, [open, popupState]);

	return (
		<Popup
			setOpen={() => (setOpen ? setOpen() : handleClose())}
			open={open ? open : !!popupState}
			container={'div'}
		>
			<h2 className="mb-32">{t('addstory')}</h2>
			<div className="popup-form__inner">
				{!!statePhoto ? (
					<div className={`example__photo ml-auto mr-auto`}>
						<img
							src={statePhoto.preview}
							alt={t('example')}
						/>
						<span
							className="icon-remove"
							onClick={() => dispatch(setAddStoriesPhoto(false))}
						>
							<Icon
								size={'s'}
								spritePath={'close'}
							/>
						</span>
					</div>
				) : !!stateVideo ? (
					<div className={`example__photo ml-auto mr-auto`}>
						<video
							src={stateVideo.preview}
							width="190px"
							height="340px"
							controls
							ref={videoRef}
						></video>
						<span
							className="icon-remove"
							onClick={() => dispatch(setAddStoriesVideo(false))}
						>
							<Icon
								size={'s'}
								spritePath={'close'}
							/>
						</span>
					</div>
				) : media?.length > 0 ? (
					<div className={`example__photo ml-auto mr-auto`}>
						{media[0]?.type?.includes('video') ? (
							<video
								width="340px"
								height="190px"
								controls
								ref={videoRef}
								src={media[0]?.preview}
							/>
						) : (
							<img
								src={media[0]?.preview ?? media[0]}
								alt={t('example')}
							/>
						)}

						<span
							className="icon-remove"
							onClick={() => setMedia(null)}
						>
							<Icon
								size={'s'}
								spritePath={'close'}
							/>
						</span>
					</div>
				) : (
					<StoryZone
						slug={slug}
						data={media}
						setData={setMedia}
						accept={{
							'image/jpeg': ['.jpg', '.jpeg', '.JPG', '.JPEG'],
							'image/png': ['.png', '.PNG'],
							'image/webp': ['.webp', '.WEBP'],
							'video/mp4': ['.mp4', '.MP4'],
							'video/quicktime': ['.mov', '.MOV'],
							'video/x-ms-wmv': ['.wmv', '.WMV'],
							'video/x-msvideo': ['.avi', '.AVI'],
							'video/x-matroska': ['.mkv', '.MKV'],
						}}
						type="mixed"
					/>
				)}
				<InputInLabel
					type={'textarea'}
					placeholder={`${t('until')} 100 ${t('symbols')}`}
					value={descValue}
					onChange={descChange}
					clazz={'mt-16'}
				>
					{t('desc')} {descValueLength}
					/100
					{descValueLength === 100 && (
						<ErrorMessage
							message={`${t('maxval')} 100 ${t('symbols')}`}
						/>
					)}
				</InputInLabel>
				{publish_price > 0 && (
					<div class="d-flex fd-column justify-center align-center">
						<p className="text-center title_h2">
							{t('storiespublishing')} {t('ispaid')} -{' '}
							<span className="color-green d-inline-flex align-center gap-4">
								{publish_price}

								<Icon
									style={{ fontSize: '0.7em' }}
									spritePath={'erocoin'}
								/>
							</span>
						</p>

						<p className="text-center mt-8">
							{t('ormake')}{' '}
							<Link
								style={{ padding: '2px 8px' }}
								className="upad__status__elite invisible"
								to="/guide/#statuses"
							>
								Elite
							</Link>{' '}
							{t('and')}
							<br />
							{t('publishstories')}!
						</p>
					</div>
				)}
				<LoadingButton
					isLoading={loading || loadingPrice}
					size={'l'}
					clazz={'button--green justify-center mt-16'}
					onClick={onSubmit}
					disabled={!statePhoto && !media && !stateVideo}
				>
					{t('publish')} {publish_price > 0 ? `${publish_price}` : ''}{' '}
					{publish_price > 0 ? (
						<Icon
							style={{ fontSize: '16px' }}
							spritePath={'erocoin'}
						/>
					) : null}
				</LoadingButton>
				{publish_price === 0 && (
					<p className="text-center">
						{t('eliteallow')} {t('publishstories')}!
					</p>
				)}
			</div>
		</Popup>
	);
};

export default AddStoriesPopup;
